import React, { Fragment, useContext, useEffect, useState } from "react";
import OnlyLogoNavbar from "../components/navbars/OnlyLogoNavbar";
import $ from "jquery";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Password from "../components/inputs/Password";
import ModalWithEmail from "../components/modals/ModalWithEmail";
import { validatePassword } from "../commonData";
import { BasicContext } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../requests";
import ContactModal from "../components/modals/ContactModal";
import { Checkbox } from "semantic-ui-react";

const SetNewPassword = () => {
    const { t } = useTranslation();
    const { setAlerts, logout, loading, setLoading, checkServerData } = useContext(BasicContext);
    const [showAlert, setShowAlert] = useState(false);
    const [resetPasswordModal, setResetPasswordModal] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const [account, setAccount] = useState(null);
    let location = useLocation();
    const navigate = useNavigate();
    const [showContactModal, setShowContactModal] = useState(false);

    useEffect(() => {
        $("main").css("min-height", `${window.innerHeight - $("#footerMain").outerHeight()}px`);
        logout("noAlertSetNewPassword");
        if (location.pathname && location.search) {
            checkLinkValidation(location.pathname + location.search);
        } else {
            setShowAlert({ variant: "danger", message: t("error.linkIsInvalid") });
            setLoading(false);
        }
        // eslint-disable-next-line
    }, []);

    const checkLinkValidation = async (link) => {
        const res = await postMethod("/check-link-is-valid", { link: link });
        if (res.status !== 200) {
            setShowAlert({ variant: "danger", message: t(`error.${res.response ? res.response.data.code : res.data ? res.data.code : res.code}`) });
        } else {
            const accountData = res.data.accountData;
            setAccount({
                show: {
                    phone: accountData.user_phone || accountData.user_phone.length > 0 ? false : true,
                    regulations: accountData.user_terms_agreement === "Y" ? false : true,
                    rodo: accountData.user_rodo_agreement === "Y" ? false : true,
                    ecc: accountData.user_ecc_agreement === "Y" ? false : true,
                    newsletter: accountData.user_newsletter_agreement === "Y" ? false : true,
                },
                user_terms_agreement: accountData.user_terms_agreement,
                user_rodo_agreement: accountData.user_rodo_agreement,
                user_ecc_agreement: accountData.user_ecc_agreement,
                user_newsletter_agreement: accountData.user_newsletter_agreement,
                userID: accountData.user_id,
                user_phone: accountData.user_phone,
                password: "",
                repeatPassword: "",
            });
        }
        setLoading(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (account.password.length === 0) {
            $("#registerFormPassword").addClass("is-invalid");
            errors.push(t("error.emptyFirstPassword"));
        } else if (!validatePassword(account.password)) {
            $("#registerFormPassword").addClass("is-invalid");
            errors.push(t("error.invalidPassword"));
        }
        if (account.repeatPassword.length === 0) {
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.emptySecondPassword"));
        } else if (!validatePassword(account.repeatPassword)) {
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.invalidPassword"));
        }

        if (account.password !== account.repeatPassword) {
            $("#registerFormPassword").addClass("is-invalid");
            $("#registerFormRepeatPassword").addClass("is-invalid");
            errors.push(t("error.passwordsAreNotTheSame"));
        }

        if (account.user_phone.length === 0 || !account.user_phone.replace(/\s+/, "")) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(account.user_phone)) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        } else if (account.user_phone.length > 30) {
            $("#registerFormphone").addClass("is-invalid");
            errors.push(t("error.userPhoneTooLong"));
        } else $("#registerFormphone").removeClass("is-invalid");

        if (!account.user_terms_agreement) {
            $("#registerFormRegulations").addClass("is-invalid");
            errors.push(t("error.notCheckedRegulations"));
        }
        if (!account.user_rodo_agreement) {
            $("#registerFormRodo").addClass("is-invalid");
            errors.push(t("error.notCheckedRodo"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.settingPassword") }]);
            setBlockForm(true);
            setPassword();
        }
    };

    const setPassword = async () => {
        const res = await postMethod("/set-new-password", { user: account });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2000 }]);
            window.scrollTo(0, 0);
            navigate("/app");
        } else setBlockForm(false);
    };

    return (
        <Fragment>
            <OnlyLogoNavbar />
            <main>
                <Container id="setNewPassword">
                    {loading ? (
                        <Row>
                            <Col xs={12} className="text-center mt-5">
                                <h1 className="h3">{t("loadingData")}</h1>
                            </Col>
                        </Row>
                    ) : showAlert ? (
                        <Row>
                            <Col xs={12} className="my-3">
                                <Alert variant="danger">
                                    <p>
                                        <FontAwesomeIcon icon={faCircleExclamation} className="me-2" /> {showAlert}
                                    </p>
                                    <p>
                                        <Button variant="outline-primary" onClick={() => setResetPasswordModal(true)} className="d-inline-block me-3">
                                            {t("resetPassOneAgain")}
                                        </Button>
                                        <Button variant="outline-primary" onClick={() => setShowContactModal(true)} className="d-inline-block">
                                            {t("menu.contact")}
                                        </Button>
                                    </p>
                                </Alert>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col className="border shadow my-lg-5" lg={{ span: 6, offset: 3 }} xs={12}>
                                <Row>
                                    <Col className="p-3 bg-darker">
                                        <div className="text-center">
                                            <h2 className="h3 my-5">{t("setNewPass.title")}</h2>
                                            <p className="ft-6 mb-4">{t("setNewPass.text")}</p>
                                        </div>
                                        <Form onSubmit={checkValidation}>
                                            {/* only for disabling warning: "Password forms should have (optionally hidden) username fields for accessibility:"*/}
                                            <input type="password" name="password" autoComplete="username password" style={{ display: "none" }} />
                                            <Form.Group controlId="accountPassword">
                                                <div className="mb-1">
                                                    <Password
                                                        autoComplete="new-account.password"
                                                        value={account.password}
                                                        onChange={(e) => {
                                                            setAccount({ ...account, password: e.target.value });
                                                            $("#accountPassword").removeClass("is-invalid");
                                                        }}
                                                        disabled={blockForm}
                                                        btnID="showPass"
                                                        label={t("password")}
                                                        helper={t("passwordHelper")}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="accountRepeatPassword">
                                                <Password
                                                    autoComplete="new-password2"
                                                    value={account.repeatPassword}
                                                    onChange={(e) => {
                                                        setAccount({ ...account, repeatPassword: e.target.value });
                                                        $("accountRepeatPassword").removeClass("is-invalid");
                                                    }}
                                                    disabled={blockForm}
                                                    btnID="repeatPass"
                                                    rpp
                                                />
                                            </Form.Group>

                                            {account.show.phone && (
                                                <Form.Group className="mb-3" controlId={`registerFormphone`}>
                                                    <Form.Label className="w-100">
                                                        {t(`registerForm.phone`)} <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        value={account.user_phone}
                                                        onChange={(el) => setAccount({ ...account, user_phone: el.target.value })}
                                                        placeholder={t(`registerForm.phonePlaceholder`)}
                                                        type="text"
                                                        disabled={blockForm}
                                                    />
                                                </Form.Group>
                                            )}

                                            {account.show.regulations && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={
                                                            <label className="form-label">
                                                                {t("registerForm.regulations")} <span className="text-danger">*</span>
                                                                <br />
                                                                <a href="/files/Regulamin-PT-2025.pdf" target="_blank">
                                                                    {t("studioRegulations")}
                                                                </a>
                                                            </label>
                                                        }
                                                        checked={account.user_terms_agreement}
                                                        onChange={() => {
                                                            setAccount({ ...account, user_terms_agreement: !account.user_terms_agreement });
                                                            $("#registerFormRegulations").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormRegulations"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.rodo && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={
                                                            <label className="form-label">
                                                                {t("registerForm.rodo")} <span className="text-danger me-3">*</span>
                                                                <a href="/files/Pole_Therapy_polityka_prywatności.pdf" target="_blank">
                                                                    {t("privacyPolicy")}
                                                                </a>
                                                            </label>
                                                        }
                                                        checked={account.user_rodo_agreement}
                                                        onChange={() => {
                                                            setAccount({ ...account, user_rodo_agreement: !account.user_rodo_agreement });
                                                            $("#registerFormRodo").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormRodo"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.ecc && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={<label className="form-label">{t("registerForm.ecc")}</label>}
                                                        checked={account.user_ecc_agreement}
                                                        onChange={() => {
                                                            setAccount({ ...account, user_ecc_agreement: !account.user_ecc_agreement });
                                                            $("#registerFormEcc").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormEcc"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.newsletter && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={<label className="form-label">{t("registerForm.newsletter")}</label>}
                                                        checked={account.user_newsletter_agreement}
                                                        onChange={() => {
                                                            setAccount({ ...account, user_newsletter_agreement: !account.user_newsletter_agreement });
                                                            $("#registerFormNewsletter").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormNewsletter"
                                                    />
                                                </Form.Group>
                                            )}
                                            <div className="text-center">
                                                <Button type="submit" className="mb-3">
                                                    {t("setNewPass.submitBtn")}
                                                </Button>
                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}
                </Container>
            </main>

            {resetPasswordModal ? (
                <ModalWithEmail
                    blockForm={blockForm}
                    show={resetPasswordModal}
                    onProceed={(data) => {
                        setBlockForm(true);
                        setPassword(data);
                    }}
                    onClose={() => setResetPasswordModal(false)}
                    translate={"resetPasswordModal"}
                />
            ) : null}
            {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
        </Fragment>
    );
};

export default SetNewPassword;
